import axios from 'axios';

import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import { downloadFile } from 'containers/App/screens/Foundation/utils/downloadFile';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_PA_CHANGE_OPTION_REQUEST = 'FETCH_PA_CHANGE_OPTION_REQUEST';
const FETCH_PA_CHANGE_OPTION_SUCCESS = 'FETCH_PA_CHANGE_OPTION_SUCCESS';
const FETCH_PA_CHANGE_OPTION_FAIL = 'FETCH_PA_CHANGE_OPTION_FAIL';

const FETCH_WORK_HISROTY_REPORT_REQUEST = 'FETCH_WORK_HISROTY_REPORT_REQUEST';
const FETCH_WORK_HISROTY_REPORT_SUCCESS = 'FETCH_WORK_HISROTY_REPORT_SUCCESS';
const FETCH_WORK_HISROTY_REPORT_FAIL = 'FETCH_WORK_HISROTY_REPORT_FAIL';

const FETCH_EDUCATION_REPORT_REQUEST = 'FETCH_EDUCATION_REPORT_REQUEST';
const FETCH_EDUCATION_REPORT_SUCCESS = 'FETCH_EDUCATION_REPORT_SUCCESS';
const FETCH_EDUCATION_REPORT_FAIL = 'FETCH_EDUCATION_REPORT_FAIL';

const FETCH_PA_CHANGE_RECORDS_REPORT_REQUEST = 'FETCH_PA_CHANGE_RECORDS_REPORT_REQUEST';
const FETCH_PA_CHANGE_RECORDS_REPORT_SUCCESS = 'FETCH_PA_CHANGE_RECORDS_REPORT_SUCCESS';
const FETCH_PA_CHANGE_RECORDS_REPORT_FAIL = 'FETCH_PA_CHANGE_RECORDS_REPORT_FAIL';

const FETCH_OM_CHANGE_RECORDS_REPORT_REQUEST = 'FETCH_OM_CHANGE_RECORDS_REPORT_REQUEST';
const FETCH_OM_CHANGE_RECORDS_REPORT_SUCCESS = 'FETCH_OM_CHANGE_RECORDS_REPORT_SUCCESS';
const FETCH_OM_CHANGE_RECORDS_REPORT_FAIL = 'FETCH_OM_CHANGE_RECORDS_REPORT_FAIL';

const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS';
const FETCH_EMPLOYEES = 'FETCH_EMPLOYEES';

export default function reducer(state = {
  isLoading: false,
  isDownloading: false,
  paChangeOption: [],
}, action) {
  switch (action.type) {
    case FETCH_PA_CHANGE_OPTION_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_PA_CHANGE_OPTION_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        paChangeOption: action.response.data,
      });
    case FETCH_PA_CHANGE_OPTION_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
      });
    case FETCH_WORK_HISROTY_REPORT_REQUEST:
      return Object.assign({}, state, {
        isDownloading: true,
      });
    case FETCH_WORK_HISROTY_REPORT_SUCCESS:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    case FETCH_WORK_HISROTY_REPORT_FAIL:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    case FETCH_EDUCATION_REPORT_REQUEST:
      return Object.assign({}, state, {
        isDownloading: true,
      });
    case FETCH_EDUCATION_REPORT_SUCCESS:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    case FETCH_EDUCATION_REPORT_FAIL:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    case FETCH_PA_CHANGE_RECORDS_REPORT_REQUEST:
      return Object.assign({}, state, {
        isDownloading: true,
      });
    case FETCH_PA_CHANGE_RECORDS_REPORT_SUCCESS:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    case FETCH_PA_CHANGE_RECORDS_REPORT_FAIL:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    case FETCH_OM_CHANGE_RECORDS_REPORT_REQUEST:
      return Object.assign({}, state, {
        isDownloading: true,
      });
    case FETCH_OM_CHANGE_RECORDS_REPORT_SUCCESS:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    case FETCH_OM_CHANGE_RECORDS_REPORT_FAIL:
      return Object.assign({}, state, {
        isDownloading: false,
      });
    default:
      return state;
  }
}

// 以server角度出發的時間偏移
const _headers = { 'Timezone-Offset': new Date().getTimezoneOffset() * -1 };

export function fetchPAChangeOption() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `ReportCenter/PaChangeContentOption`,
      method: 'GET',
      types: [
        FETCH_PA_CHANGE_OPTION_REQUEST,
        FETCH_PA_CHANGE_OPTION_SUCCESS,
        FETCH_PA_CHANGE_OPTION_FAIL,
      ],
    },
  };
}

export function fetchWorkHistoryReport(formData) {
  const downloadUrl = NEWTUBE_API_SERVER + `ReportCenter/WorkDoc`;
  const types = [
    FETCH_WORK_HISROTY_REPORT_REQUEST,
    FETCH_WORK_HISROTY_REPORT_SUCCESS,
    FETCH_WORK_HISROTY_REPORT_FAIL,
  ];
  return downloadFile(downloadUrl, types, formData, 'POST');
}

export function fetchEducationReport(formData) {
  const downloadUrl = NEWTUBE_API_SERVER + `ReportCenter/EducationDoc`;
  const types = [
    FETCH_EDUCATION_REPORT_REQUEST,
    FETCH_EDUCATION_REPORT_SUCCESS,
    FETCH_EDUCATION_REPORT_FAIL,
  ];
  return downloadFile(downloadUrl, types, formData, 'POST');
}

export function fetchPAChangeRecordsReport(formData) {
  const downloadUrl = url.WEBBFF_API_SERVER + `Report/EmployeeChangeRecords`;
  const types = [
    FETCH_PA_CHANGE_RECORDS_REPORT_REQUEST,
    FETCH_PA_CHANGE_RECORDS_REPORT_SUCCESS,
    FETCH_PA_CHANGE_RECORDS_REPORT_FAIL,
  ];
  return downloadFile(downloadUrl, types, formData, 'POST', _headers);
}
export function fetchOMChangeRecordsReport(formData) {
  const downloadUrl = url.WEBBFF_API_SERVER + `Report/DepartmentChangeRecords`;
  const types = [
    FETCH_OM_CHANGE_RECORDS_REPORT_REQUEST,
    FETCH_OM_CHANGE_RECORDS_REPORT_SUCCESS,
    FETCH_OM_CHANGE_RECORDS_REPORT_FAIL,
  ];
  return downloadFile(downloadUrl, types, formData, 'POST', _headers);
}

export function fetchDepartments() {
  return {
    type: FETCH_DEPARTMENTS,
    payload: axios.get(`${url.WEBBFF_API_SERVER}Department/ValidDepartments`),
  };
}

export function fetchEmployees() {
  return {
    type: FETCH_EMPLOYEES,
    payload: axios.get(`${url.WEBBFF_API_SERVER}Employee/CurrentEmployees`),
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Report/reducers/index.js
 **/